export const stoyki = {
    stoyka__sop__600x500: {
        name: "Стойка подкатная для приборов (СОП), мм",
        title: "Стойка подкатная для приборов (СОП)",
        price: 0,
        active: false,
        type: "1600x500x600",
        width: 600,
        depth: 500,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stoyka__smo__600x500: {
        name: "Стойка подкатная для оборудования (СМО), мм",
        title: "Стойка подкатная для оборудования (СМО)",
        price: 0,
        active: false,
        type: "1650x500x600",
        width: 600,
        depth: 500,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stoyka__som__600x570: {
        name: "Стойка оператора (СОМ), мм",
        title: "Стойка оператора (СОМ)",
        price: 0,
        active: false,
        type: "1900x600x570",
        width: 600,
        depth: 570,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stoyka__smp__680x500: {
        name: "Стойка подкатная для приборов (СМП), мм",
        title: "Стойка подкатная для приборов (СМП)",
        price: 0,
        active: false,
        type: "1600x500x680",
        width: 680,
        depth: 500,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stoyka__spm__600x500: {
        name: "Стойка подкатная (СПМ), мм",
        title: "Стойка подкатная (СПМ)",
        price: 0,
        active: false,
        type: "850x500x600",
        width: 600,
        depth: 500,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stoyka__spl__600x500: {
        name: "Стойка металлическая (СПЛ), мм",
        title: "Стойка металлическая (СПЛ)",
        price: 0,
        active: false,
        type: "1700x500x600",
        width: 600,
        depth: 500,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stoyka__skk__590x420: {
        name: "Стойка для картонных коробок (СКК), мм",
        title: "Стойка для картонных коробок (СКК)",
        price: 0,
        active: false,
        type: "1600x420x590",
        width: 590,
        depth: 420,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stoyka__sur__1200x600: {
        name: "Стойка упаковочная для рулонов (СУР), мм",
        title: "Стойка упаковочная для рулонов (СУР)",
        price: 0,
        active: false,
        type: "1550x1200x600",
        width: 1200,
        depth: 600,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stoyka__sur__1400x600: {
        name: "Стойка упаковочная для рулонов (СУР), мм",
        title: "Стойка упаковочная для рулонов (СУР)",
        price: 0,
        active: false,
        type: "1550x1400x600",
        width: 1400,
        depth: 600,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stoyka__sur__1700x600: {
        name: "Стойка упаковочная для рулонов (СУР), мм",
        title: "Стойка упаковочная для рулонов (СУР)",
        price: 0,
        active: false,
        type: "1550x1700x600",
        width: 1700,
        depth: 600,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stoyka__sur__1900x600: {
        name: "Стойка упаковочная для рулонов (СУР), мм",
        title: "Стойка упаковочная для рулонов (СУР)",
        price: 0,
        active: false,
        type: "1550x1900x600",
        width: 1900,
        depth: 600,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stoyka__sop_kp__600x600: {
        name: "Стойка подкатная для приборов (СОП-КП), мм",
        title: "Стойка подкатная для приборов (СОП-КП)",
        price: 0,
        active: false,
        type: "1700x600x600",
        width: 600,
        depth: 600,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stoyka__skp_kp__700x600: {
        name: "Стойка промышленная для компьютера (СКП-КП), мм",
        title: "Стойка промышленная для компьютера (СКП-КП)",
        price: 0,
        active: false,
        type: "1600x600x700",
        width: 700,
        depth: 600,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stoyka__smp_kp__700x500: {
        name: "Стойка подкатная (СМП-КП), мм",
        title: "Стойка подкатная (СМП-КП)",
        price: 0,
        active: false,
        type: "1950x500x700",
        width: 700,
        depth: 500,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stoyka__spl_kp__800x690: {
        name: "Стойка подкатная лабораторная (СПЛ-КП), мм",
        title: "Стойка подкатная лабораторная (СПЛ-КП)",
        price: 0,
        active: false,
        type: "1600x690x800",
        width: 800,
        depth: 690,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stoyka__sr_kp__700x550: {
        name: "Стойка подкатная ремонтная (СР-КП), мм",
        title: "Стойка подкатная ремонтная (СР-КП)",
        price: 0,
        active: false,
        type: "1950x550x700",
        width: 700,
        depth: 550,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stoyka__spk_kp__700x550: {
        name: "Стойка подкатная компьтерная (СПК-КП), мм",
        title: "Стойка подкатная компьтерная (СПК-КП)",
        price: 0,
        active: false,
        type: "1950x550x700",
        width: 700,
        depth: 550,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stoyka__snp_kp__595x500: {
        name: "Стойка подкатная ремонтная (СР-КП), мм",
        title: "Стойка подкатная ремонтная (СР-КП)",
        price: 0,
        active: false,
        type: "1700x500x595",
        width: 595,
        depth: 500,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
};
export const zink__stoyka = {
    zink__sop: {
        name: "Комплект оцинкованных покрытий на полки, шт",
        price: 0,
        active: false,
        type: "1",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zink__smo: {
        name: "Комплект оцинкованных покрытий на полки, шт",
        price: 0,
        active: false,
        type: "1",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zink__smp: {
        name: "Комплект оцинкованных покрытий на полки, шт",
        price: 0,
        active: false,
        type: "1",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zink__spm: {
        name: "Комплект оцинкованных покрытий на полки, шт",
        price: 0,
        active: false,
        type: "1",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zink__sop_kp: {
        name: "Комплект оцинкованных покрытий на полки, шт",
        price: 0,
        active: false,
        type: "1",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
export const dop_polka_pfk = {
    polka_pfk__1: {
        name: "Дополнительная полка ПФК, мм",
        price: 0,
        active: false,
        type: "500x600",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pfk__2: {
        name: "Дополнительная полка ПФК, мм",
        price: 0,
        active: false,
        type: "500x600",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pfk__3: {
        name: "Дополнительная полка ПФК, мм",
        price: 0,
        active: false,
        type: "500x600",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
export const derzhatel_rulona__stoyka__1 = {
    derzhatel_rulona__stoyka__1200__1: {
        name: "Держатель рулона, мм",
        price: 0,
        active: false,
        type: "1200",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_rulona__stoyka__1400__1: {
        name: "Держатель рулона, мм",
        price: 0,
        active: false,
        type: "1400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_rulona__stoyka__1700__1: {
        name: "Держатель рулона, мм",
        price: 0,
        active: false,
        type: "1700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_rulona__stoyka__1900__1: {
        name: "Держатель рулона, мм",
        price: 0,
        active: false,
        type: "1700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
export const derzhatel_rulona__stoyka__2 = {
    derzhatel_rulona__stoyka__1200__2: {
        name: "Держатель рулона, мм",
        price: 0,
        active: false,
        type: "1200",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_rulona__stoyka__1400__2: {
        name: "Держатель рулона, мм",
        price: 0,
        active: false,
        type: "1400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_rulona__stoyka__1700__2: {
        name: "Держатель рулона, мм",
        price: 0,
        active: false,
        type: "1700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_rulona__stoyka__1900__2: {
        name: "Держатель рулона, мм",
        price: 0,
        active: false,
        type: "1700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
export const derzhatel_rulona__stoyka__3 = {
    derzhatel_rulona__stoyka__1200__3: {
        name: "Держатель рулона, мм",
        price: 0,
        active: false,
        type: "1200",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_rulona__stoyka__1400__3: {
        name: "Держатель рулона, мм",
        price: 0,
        active: false,
        type: "1400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_rulona__stoyka__1700__3: {
        name: "Держатель рулона, мм",
        price: 0,
        active: false,
        type: "1700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_rulona__stoyka__1900__3: {
        name: "Держатель рулона, мм",
        price: 0,
        active: false,
        type: "1700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
export const derzhatel_rulona__stoyka__4 = {
    derzhatel_rulona__stoyka__1200__4: {
        name: "Держатель рулона, мм",
        price: 0,
        active: false,
        type: "1200",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_rulona__stoyka__1400__4: {
        name: "Держатель рулона, мм",
        price: 0,
        active: false,
        type: "1400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_rulona__stoyka__1700__4: {
        name: "Держатель рулона, мм",
        price: 0,
        active: false,
        type: "1700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_rulona__stoyka__1900__4: {
        name: "Держатель рулона, мм",
        price: 0,
        active: false,
        type: "1700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
export const ogranichitel__stoyka__zad = {
    ogranichitel__stoyka__zad__1: {
        name: "Задний ограничитель полки, мм",
        price: 0,
        active: false,
        type: "500x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    ogranichitel__stoyka__zad__2: {
        name: "Задний ограничитель полки, мм",
        price: 0,
        active: false,
        type: "500x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    ogranichitel__stoyka__zad__3: {
        name: "Задний ограничитель полки, мм",
        price: 0,
        active: false,
        type: "500x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    ogranichitel__stoyka__zad__4: {
        name: "Задний ограничитель полки, мм",
        price: 0,
        active: false,
        type: "500x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    ogranichitel__stoyka__zad__5: {
        name: "Задний ограничитель полки, мм",
        price: 0,
        active: false,
        type: "500x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
export const ogranichitel__stoyka__bok = {
    ogranichitel__stoyka__bok__1: {
        name: "Комплект боковых ограничителей полки, мм",
        price: 0,
        active: false,
        type: "500x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    ogranichitel__stoyka__bok__2: {
        name: "Комплект боковых ограничителей полки, мм",
        price: 0,
        active: false,
        type: "500x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    ogranichitel__stoyka__bok__3: {
        name: "Комплект боковых ограничителей полки, мм",
        price: 0,
        active: false,
        type: "500x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    ogranichitel__stoyka__bok__4: {
        name: "Комплект боковых ограничителей полки, мм",
        price: 0,
        active: false,
        type: "500x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    ogranichitel__stoyka__bok__5: {
        name: "Комплект боковых ограничителей полки, мм",
        price: 0,
        active: false,
        type: "500x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
